module.exports = __webpack_public_path__ + "static/img/birth-chart-home-default.dee518d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/astrology/birth-chart-home-default.png
// module id = I/E/
// module chunks = 0